export default __webpack_public_path__ + "static/media/governance.0026c9ad.svg";